var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"succeed"},[_c('div',{staticClass:"activityDesc",domProps:{"innerHTML":_vm._s(_vm.activityInfoData.home_register_desc)}})])}
var staticRenderFns = []

export { render, staticRenderFns }